import {
  selectNotificationView as selectNotificationViewModel,
  type NotificationViewCopy,
  type NotificationViewModel,
  type WorldState,
} from "@dawn/engine";
import type { LocaleId } from "./locale.ts";
import { resolveLocalizedNotificationCopy } from "./notificationKeys.ts";
import { getGameStrings } from "./resolveStrings.ts";

export function createNotificationViewCopy(locale: LocaleId): NotificationViewCopy {
  const strings = getGameStrings(locale);
  return {
    hudNotificationsTooltip: strings.hudNotificationsTooltip,
    notificationEmpty: strings.notificationEmpty,
    notificationOk: strings.notificationOk,
    notificationCancel: strings.notificationCancel,
    notificationMarkDone: strings.notificationMarkDone,
    notificationPageOf: strings.notificationPageOf,
    notificationPageIndicatorOf: strings.notificationPageIndicatorOf,
    resolveKind: (kind) => resolveLocalizedNotificationCopy(kind, strings),
  };
}

/** Localized convenience over the engine selector — production signature. */
export function selectNotificationView(
  state: WorldState,
  locale: LocaleId,
): NotificationViewModel {
  return selectNotificationViewModel(state, createNotificationViewCopy(locale));
}
